module.exports = __webpack_public_path__ + "static/img/zone-ad.4a5f0f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zone/zone-ad.jpg
// module id = rYeA
// module chunks = 1